import React from 'react';
import { Box, Button } from '@mui/material';

interface WSFilterButtonGroupProps {
  options: string[];
  selected: string;
  onChange: (value: string) => void;
}

const WSFilterButtonGroup: React.FC<WSFilterButtonGroupProps> = ({
  options,
  selected,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        border: '1px solid #098963',
        borderRadius: '30px',
        padding: '3px',
        backgroundColor: '#F6FCFA',
        width: 'fit-content',
        height:35,
      }}
    >
      {options.map((option) => (
        <Button
          key={option}
          onClick={() => onChange(option)}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            height:'28px!important',
            color: selected === option ? '#fff' : '#6B6B6B',
            backgroundColor: selected === option ? '#098963' : 'transparent',
            borderRadius: '30px',
            paddingX: 2,
            '&:hover': {
              backgroundColor: selected === option ? '#066e4f' : '#e0f3ec',
            },
            fontSize: '0.875rem!important',
            minWidth: 'auto',
          }}
        >
          {option}
        </Button>
      ))}
    </Box>
  );
};

export default WSFilterButtonGroup;
